import React, { useEffect } from "react";
// react-redux
import { useDispatch, useSelector } from "react-redux";
// react-anchor-link-smooth-scroll
import AnchorLink from "react-anchor-link-smooth-scroll";
// @material-ui
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
// view
import PostsView from "../PostsView/PostsView";
import ArticleView from "../ArticleView/ArticleView";
// components
import MainSlickSlider from "../../components/SlickSlider/MainSlickSlider";
import SideProfile from "../../components/Profile/SideProfile";
import RecommendedPosts from "../../components/RecommendedPosts/RecommendedPosts";
import CategoryList from "../../components/CategoryList/CategoryList";
import SNSList from "../../components/SNSList/SNSList";
import Header from "../../components/Header/Header";
import CircleBtn from "../../components/CircleBtn/CircleBtn";
// styles
import styles from "./MainViewStyles";
// action
import {
  fetchSiteBasicInfo,
  fetchSnsInfo,
} from "../../store/actions/WordPressApiAction";

const useStyles = makeStyles(styles);
/**
 * メインページ。記事一覧か、記事詳細かを判断し対応したコンポーネントを表示する。
 * @param {*} props
 */
export default function MainView(props) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const basicInfo = useSelector((state) => state.fetchBasicInfoReducer);
  const snsInfo = useSelector((state) => state.fetchSnsInfoReducer);

  //記事情報確認
  const articleSlug = props.match.params.slug;
  const categoryId = props.match.params.categoryId;
  console.log("articleSlug：" + articleSlug);
  console.log("categoryId：" + categoryId);

  //サイト基本情報取得
  useEffect(() => {
    dispatch(fetchSiteBasicInfo());
    dispatch(fetchSnsInfo());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * 投稿一覧画面(PostsView)か記事詳細画面(ArticleView)を決定する。
   */
  function determineDisplayView() {
    /**
     * 遷移先の画面を選択する。
     */
    if (articleSlug) {
      return <ArticleView slug={articleSlug} basicInfo={basicInfo} />;
    } else if (categoryId) {
      return <PostsView categoryId={categoryId} basicInfo={basicInfo} />;
    } else {
      return <PostsView basicInfo={basicInfo} />;
    }
  }
  return (
    <div>
      <Header
        brand={basicInfo.site_title}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 400,
          color: "white",
        }}
      />
      <div id="Top"></div>
      <MainSlickSlider headerInfo={basicInfo.header_info} />
      <Grid container spacing={0} className={classes.mainViewContainer}>
        <Grid item xs={12} sm={8} container className={classes.gridMain}>
          {determineDisplayView()}
        </Grid>
        <Grid item xs={12} sm={4} className={classes.gridSide}>
          <SideProfile profileInfo={basicInfo.profile_info} />
          <SNSList snsInfo={snsInfo} />
          <RecommendedPosts
            siteURL={basicInfo.site_url}
            RecommendedPosts={basicInfo.recommend_posts}
          />
          <CategoryList />
        </Grid>
        <AnchorLink href="#Top" className={classes.link}>
          <CircleBtn />
        </AnchorLink>
      </Grid>
    </div>
  );
}
